// for state its important to have initial default value
export const LoadingColor = (state = "#999" /*, action*/) => {
    return state;
};
